import { ProjectRepositoryImpl } from '../Data/ProjectRepositoryImpl';
import { CreateProjectUseCase } from '../Domain/usecases/CreateProjectUseCase';
import { CreateWithdrawForProjectUseCase } from '../Domain/usecases/CreateWithdrawForProjectUseCase';
import { CreateWithdrawUseCase } from '../Domain/usecases/CreateWithdrawUseCase';
import { GetCampaignUseCase } from '../Domain/usecases/GetCampaignUseCase';
import { GetProjectUseCase } from '../Domain/usecases/GetProjectUseCase';
import { GetProjectImageUseCase } from '../Domain/usecases/GetProjectImageUseCase';
import { SearchProjectImagesUseCase } from '../Domain/usecases/SearchProjectImagesUseCase';
import { GetOrganizationUseCase } from '../Domain/usecases/GetOrganizationUseCase';
import { GetSpProjectUseCase } from '../Domain/usecases/GetSpProjectUseCase';
import { GetSpProjectWithUsersUseCase } from '../Domain/usecases/GetSpProjectWithUsersUseCase';
import { GetWithdrawUseCase } from '../Domain/usecases/GetWithdrawUseCase';
import { CheckProjectIdUseCase } from '../Domain/usecases/CheckProjectIdUseCase';
import { SearchProjectsUseCase } from '../Domain/usecases/SearchProjectsUseCase';
import { SearchCampaignsUseCase } from '../Domain/usecases/SearchCampaignsUseCase';
import { SearchOrganizationsUseCase } from '../Domain/usecases/SearchOrganizationsUseCase';
import { SearchWithdrawProjectsUseCase } from '../Domain/usecases/SearchWithdrawProjectsUseCase';
import { SearchWithdrawUseCase } from '../Domain/usecases/SearchWithdrawUseCase';
import { UpdateProjectUseCase } from '../Domain/usecases/UpdateProjectUseCase';
import { UpdateWithdrawUseCase } from '../Domain/usecases/UpdateWithdrawUseCase';
import { UploadProjectImageUseCase } from '../Domain/usecases/UploadProjectImageUseCase';
import { CreateProjectPostUseCase } from '../Domain/usecases/CreateProjectPostUseCase';
import { UpdateProjectPostUseCase } from '../Domain/usecases/UpdateProjectPostUseCase';
import { DeleteProjectPostUseCase } from '../Domain/usecases/DeleteProjectPostUseCase';
import { GetProjectPostUseCase } from '../Domain/usecases/GetProjectPostUseCase';
import { SearchProjectPostsUseCase } from '../Domain/usecases/SearchProjectPostsUseCase';
import { SumProjectDonorsUseCase } from '../Domain/usecases/SumProjectDonorsUseCase';

const repository = new ProjectRepositoryImpl();

export const projectUseCases = {
  // Projects
  searchProjects: new SearchProjectsUseCase(repository),
  getProject: new GetProjectUseCase(repository),
  sumProjectDonors: new SumProjectDonorsUseCase(repository),
  checkProjectId: new CheckProjectIdUseCase(repository),
  createProject: new CreateProjectUseCase(repository),
  updateProject: new UpdateProjectUseCase(repository),
  uploadProjectImage: new UploadProjectImageUseCase(repository),
  getProjectImage: new GetProjectImageUseCase(repository),
  searchProjectImages: new SearchProjectImagesUseCase(repository),

  // SP Projects
  getSpProject: new GetSpProjectUseCase(repository),
  getSpProjectWithUsers: new GetSpProjectWithUsersUseCase(repository),

  // Organization
  getOrganization: new GetOrganizationUseCase(repository),
  searchOrganizations: new SearchOrganizationsUseCase(repository),

  // Withdraw
  searchWithdrawProjects: new SearchWithdrawProjectsUseCase(repository),
  createWithdraw: new CreateWithdrawUseCase(repository),
  getWithdraw: new GetWithdrawUseCase(repository),
  searchWithdraw: new SearchWithdrawUseCase(repository),
  createWithdrawForProject: new CreateWithdrawForProjectUseCase(repository),
  updateWithdraw: new UpdateWithdrawUseCase(repository),

  // Campaign
  searchCampaigns: new SearchCampaignsUseCase(repository),
  getCampaign: new GetCampaignUseCase(repository),

  // ProjectPost
  createProjectPost: new CreateProjectPostUseCase(repository),
  updateProjectPost: new UpdateProjectPostUseCase(repository),
  deleteProjectPost: new DeleteProjectPostUseCase(repository),
  getProjectPost: new GetProjectPostUseCase(repository),
  searchProjectPosts: new SearchProjectPostsUseCase(repository),
};


